module.exports = __webpack_public_path__ + "static/media/Jeanne Torbett Headshot.428e4c67.jpeg";